import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import { Locale } from '../i18n/translations';

export const Header: React.FC = () => {
  const { locale, locales, setLocale, t } = useI18n();

  return (
    <header className="relative z-10 bg-black">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-4">
          <img src="/images/appvanz-logo.png" alt="Cinema Zone Logo" className="h-16 sm:h-20" />
          <div className="hidden sm:block">
            <div className="text-xl font-bold text-white">{t('appName')}</div>
            <div className="text-sm text-stone-300">{t('partnerLabel')}</div>
          </div>
        </Link>
        <nav className="flex items-center gap-3 text-sm font-medium text-stone-300">
          {/*<NavLink to="/" className={({ isActive }) => (isActive ? 'rounded-md bg-[#ffd460] px-3 py-2 text-stone-950' : 'px-1 hover:text-white')}>*/}
          {/*  {t('browse')}*/}
          {/*</NavLink>*/}
          <label className="sr-only" htmlFor="language-selector">{t('languageSelectorLabel')}</label>
          <select
            id="language-selector"
            className="rounded-md border border-stone-700 bg-black px-2 py-2 text-stone-200 outline-none hover:border-[#ffd460] focus:border-[#ffd460] focus:ring-2 focus:ring-[#ffd460]/50"
            value={locale}
            onChange={(event) => setLocale(event.target.value as Locale)}
            aria-label={t('languageSelectorLabel')}
          >
            {locales.map((value) => (
              <option key={value} value={value}>
                {value === 'zh-Hant' ? t('languageTraditionalChinese') : value === 'zh-Hans' ? t('languageSimplifiedChinese') : t('languageEnglish')}
              </option>
            ))}
          </select>
        </nav>
      </div>
    </header>
  );
};
